/**
 * Телефон хранится в формате +7XXXXXXXXXX, принимается в любой записи:
 * «8 701 123 45 67», «701 123-45-67», «+7 (701) 123-45-67».
 * Пустая строка → '' (телефон не указан), неверный номер → null.
 */
export function normPhone(raw: string | null | undefined): string | null {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  const d = s.replace(/\D/g, '');
  if (s.startsWith('+')) {
    if (d.startsWith('7')) return d.length === 11 ? '+' + d : null;
    return d.length >= 10 && d.length <= 15 ? '+' + d : null;
  }
  if (d.length === 11 && (d[0] === '8' || d[0] === '7')) return '+7' + d.slice(1);
  if (d.length === 10 && (d[0] === '7' || d[0] === '9')) return '+7' + d;
  return null;
}

/** +77011234567 → «+7 701 123-45-67»; другие форматы возвращаются как есть. */
export function fmtPhone(p: string | null | undefined): string {
  const v = p ?? '';
  return /^\+7\d{10}$/.test(v)
    ? `+7 ${v.slice(2, 5)} ${v.slice(5, 8)}-${v.slice(8, 10)}-${v.slice(10, 12)}`
    : v;
}
